export interface PageInsight {
  id: string;
  title: string;
  source: string;
  url?: string;
  summary: string;
  category: string;
  topics: string[];
  keyInsights: string[];
  confidence: number;
  sentiment: string;
}

export function hostnameFromUrl(raw?: string): string {
  if (!raw) return 'unknown';
  try {
    return new URL(raw).hostname;
  } catch {
    return raw;
  }
}

export function mapAnalysisPayload(
  id: string,
  title: string,
  url: string | undefined,
  raw: Record<string, unknown>,
): PageInsight {
  const summary = String(raw.summary ?? raw.analysis ?? raw.content_summary ?? '').trim();
  const keyRaw = raw.key_insights ?? raw.keyInsights;
  const topicsRaw = raw.topics ?? raw.tags;
  const keyInsights = Array.isArray(keyRaw)
    ? keyRaw.map((x) => String(x).trim()).filter(Boolean)
    : [];
  const topics = Array.isArray(topicsRaw)
    ? topicsRaw.map((x) => String(x).trim()).filter(Boolean)
    : [];

  let confidence = 0;
  if (typeof raw.confidence === 'number') {
    confidence = raw.confidence <= 1 ? Math.round(raw.confidence * 100) : Math.round(raw.confidence);
  } else {
    confidence = keyInsights.length > 0 ? 75 : 55;
  }

  return {
    id,
    title: title || hostnameFromUrl(url),
    source: hostnameFromUrl(url),
    url,
    summary,
    category: String(raw.category ?? 'general'),
    topics,
    keyInsights,
    confidence,
    sentiment: String(raw.sentiment ?? 'neutral'),
  };
}

export function isLowValueTabUrl(url?: string): boolean {
  if (!url) return true;
  try {
    const u = new URL(url);
    if (u.hostname === 'localhost' && u.pathname.startsWith('/insights')) return true;
    if (u.hostname === 'mail.google.com' && u.pathname === '/mail/u/0/') return true;
  } catch {
    return false;
  }
  return false;
}
